export const sendingSettingsLinks = {
    clientListView: window.Urls.client_list_view(),
    customEmailDomain: 'https://help.makeleaps.jp/ja/articles/3950355',
    documentArchiveEditView: window.Urls.partner_document_archive_edit_view(),
    documentEmailSettingsEditView:
        window.Urls.partner_email_settings_edit_view(),
    documentSendingSettingsEdit:
        window.Urls.partner_document_sending_edit_view(),
    howToSendDocuments: 'https://help.makeleaps.jp/ja/articles/8687198',
    partnerCustomEmailDomainListView:
        window.Urls.partner_custom_email_domain_list_view(),
    partnerPeppolEditView: window.Urls.partner_peppol_edit_view(),
    sendingSettingsView: window.Urls.partner_sending_settings_view(),
};
